module.exports = __webpack_public_path__ + "img/7.9463d9db.jpg";